<div [class.fade-out]="fadeOut" class="fade-in lib-elevation-1">

  <nav class="lib-nav details" [hidden]="!data?.badge && !data?.date">
    <div *ngIf="!!data?.badge" [class]="badgeTheme">
      <span>{{data?.badge}}</span>
    </div>
    <span class="lib-spacer"></span>
    <span *ngIf="!!data?.date" class="lib-legend">{{data?.date | date: 'd MMM, h:mm a'}}</span>
  </nav>

  <div class="lib-flex">

    <p>{{data?.body}}</p>

    <figure *ngIf="!!data?.icon">
      <ngx-picture class="cover" [src]="data?.icon" [lazyLoad]="true"></ngx-picture>
    </figure>

  </div>

  <nav class="lib-nav" [ngSwitch]="data?.options?.action">
    <lib-button pTrackEvent="click" pTrackAction="action" pTrackCategory="app_notification" *ngSwitchCase="'routerLink'"
      [routerLink]="data?.options?.actionPath">
      {{data?.options?.actionLabel}}
    </lib-button>
    <a pTrackEvent="click" pTrackAction="a-href-action" pTrackCategory="app_notification" class="lib-button"
      *ngSwitchCase="'href'" [href]="data?.options?.actionPath" target="_blank">
      <span>{{data?.options?.actionLabel}}</span>
    </a>
    <span class="lib-spacer"></span>
    <lib-button pTrackEvent="click" pTrackAction="dismiss" pTrackCategory="app_notification"
      [hidden]="!data?.options?.dismissible" (click)="onDismiss($event)">
      {{data?.options?.dismissLabel}}
    </lib-button>
  </nav>

</div>
